"use strict";

var UTI = typeof UTI === "object" ? UTI : {};
UTI.isdesktop = true;

UTI.common = {
    init: function () {
        // accordions
        $(".ac-title:not(.active)").each(function () {
            $(this).next().css("display", "none");
        });
        document.documentElement.className +=
            "ontouchstart" in document.documentElement ? " touch" : " no-touch";

       //for quntity box

        $("body").on("click", ".quantity-wrap .quantity-btn", function (e) {
            e.preventDefault();
            var box = $(this).parent().find("input");
            if($(this).hasClass('min'))
            {
                if($(this).hasClass('zerook'))
                {
                    if (parseInt(box.val()) > 0) box.val(parseInt(box.val()) - 1);
                }else if (parseInt(box.val()) > 1) box.val(parseInt(box.val()) - 1);
            }else
            {
               box.val(parseInt(box.val()) + 1);
            }
            box.trigger("change");
        });


        $("body").on("click", ".ac-title", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass("active")) {
                $(this).next().removeClass("active");
                $(this).next().slideUp();
            } else {
                $(this).next().addClass("active");
                $(this).next().slideDown();
            }
            $(this).toggleClass("active");
        });

        //section custom
        $("[data-custom-class]").each(function () {
            $(this).parent().addClass($(this).attr("data-custom-class"));
        });

        //scroll throtle
        var scrollpos = 0;
        var scrollTimeout;
        var throttle = 200;

        $(window).on("scroll", function () {
            if (!scrollTimeout) {
                scrollTimeout = setTimeout(function () {
                    var goindown = window.pageYOffset > scrollpos ? true : false;
                    scrollpos = window.pageYOffset;
                    $(window).trigger("utiscroll", [window.pageYOffset, goindown]);
                    scrollTimeout = null;
                }, throttle);
            }
        });

        //video change

        $(window).resize(function () {
            if (jQuery(window).width() > 749 && !UTI.isdesktop) {
                UTI.isdesktop = true;
                $(window).trigger("uti-device-changed");
            } else if (jQuery(window).width() < 750 && UTI.isdesktop) {
                UTI.isdesktop = false;
                $(window).trigger("uti-device-changed");
            }
        });

        $(window).on("uti-device-changed", function () {
            UTI.common.loadmpfors();
        });

        UTI.common.loadmpfors();
    },
    loadmpfors: function () {
        var newmp4 = $(".hero-sou").attr("data-m");
        if (UTI.isdesktop) {
            newmp4 = $(".hero-sou").attr("data-d");
        }
        var videocontainer = $(".hero-vid");
        var videosource = $(".hero-sou");

        if (videocontainer.length) {
            videocontainer.get(0).pause();
            videosource.get(0).setAttribute("src", newmp4);
            videocontainer.get(0).load();
            //videocontainer.setAttribute('poster', newposter); //Changes video poster image
            videocontainer.get(0).play();
        }
    }
};

$(function () {
    if (jQuery(window).width() > 749 && !UTI.isdesktop) {
        UTI.isdesktop = true;
        $(window).trigger("uti-device-changed");
    } else if (jQuery(window).width() < 750 && UTI.isdesktop) {
        UTI.isdesktop = false;
        $(window).trigger("uti-device-changed");
    }
    UTI.common.init();
});


//header section
jQuery(document).ready(function() {

    //mobile nav open
    PROJ.ajaxcart.init();

    $('body').on('click', '.desk-search.set', function (e) {
        e.preventDefault();
        $('.desk-search-wrap').slideToggle();
    });

    $('body').on('click', '.mobile-nav .roll-nav .first-link', function (e) {
        e.preventDefault();
        $(this).next().slideToggle();
        $(this).toggleClass('active-plus');
    });


    $('.mainnavi-mob .first-ul .level1 > a').click(function(e)
    {
        e.stopPropagation();
        e.preventDefault();
        $(this).parent().toggleClass('closed');

    });

    $(window).on('utiscroll',function(a,b,c){
        // if(c && b >= 200)
        if(b >= 1)
        {
            $('body').addClass('scroll-down');
        }
        else
        {
            $('body').removeClass('scroll-down');
        }
    });



});


///PDP////

"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};

UTI.pdp = {
    init: function () {
        var _this = this;
        $('body').on('click', '.product-form .variable',function (e){
            e.preventDefault();
            if($(this).hasClass('active')) return;
            var thisform = $(this).parents('.product-form');
            var thisid = $(this).attr('varid');

            thisform.find('.variable').removeClass('active');
            $(this).addClass('active');
            window.history.replaceState({ }, '', '?variant='+thisid);

            var varprice = $(this).parent().find('.var-price').html();
            thisform.find('.price-replace').html(varprice);
            thisform.find('form input[name="id"]').val(thisid);

            if($(this).hasClass('available'))
            {
                thisform.find('button').removeAttr('disabled');
            }else
            {
                thisform.find('button').attr('disabled','');
            }
            if($(this).attr('data-imgvar-id') != "")
            {
                var ind = $('[data-assign-var="'+$(this).attr('data-imgvar-id')+'"]').index();
                $('.acc-gal').find('.gallery-inside').flickity( 'select', ind );
                if($('.sl-main-gal').length) Flickity.data('.sl-main-gal').select(ind);
            }

        });
    }
};
var cartAnimationOnce = 0;
"use strict"
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.ajaxcart = {
    VAR: {wait_ani:false},

    init: function () {
        var _this = this;
        // _this.updateCart();
        _this.giftwrap();

        setTimeout(function(){
            _this.animateCart();
        },100);

        if (window.location.href.indexOf("minicart=true") > -1) {
            $('body,html').addClass('mini-cart');
            setTimeout(function(){
                $('body,html').addClass('mini-cart-ani');
            },500);
        }

        $('body').on('click', '.nav-close-cart, .minicart-back', function (e) {
            e.preventDefault();
            _this.closecart();
        });

        $('body').on('click tap', '.close-upsell,.upsell-overlay', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.opencart();
            _this.closeupsell();
        });

        $('body').on('click tap', 'a.mini_cart, .cart-open, [href="/cart"]:not(.chek-btn)', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.opencart();
            _this.closeupsell();
        });

        $('body').on('click', '[data-varid]', function (e) {
            e.preventDefault();
            var varid = $(this).attr('data-varid');
            $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
            $(this).parents('.cross-slide').find('.money').text('Only '+$(this).attr('data-varprice') );
            $(this).parents('.cross-slide').find('[data-varid]').removeClass('active');
            $(this).addClass('active');
        });

        $('body').on('change', '.quick-buy select', function (e) {
            e.preventDefault();
            var varid = $(this).val();
            $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
            $(this).parents('.cross-slide').find('.money').text('Only '+$(this).find('option:selected').attr('data-varprice') );
        });


        //activate free gift with chkecnbox

        $('body').on('change', '#fgifts', function (e) {
            if(this.checked) {
                $('.free-items-box .dum').hide();
                $('.free-items-box .org').show();
            }else
            {
                $('.free-items-box .dum').show();
                $('.free-items-box .org').hide();
            }
        });


        $('body').on('click', '[data-directadd]', function (e) {
            e.preventDefault();
            _this.addItem($(this).attr('data-directadd'));
        });

        $('body').on('click', '[data-directremove]', function (e) {
            e.preventDefault();
            _this.updateItem($(this).attr('data-directremove'), 0);
        });

        $('body').on('change', '.cart-item [data-proid].qty-input', function (e) {
            e.preventDefault();
            var ids = $(this).attr('data-proid');
            var qty = $(this).val();
            _this.updateItem(ids, qty);
            setTimeout(function(){
                if($('body').hasClass('template-cart'))
                {
                    location.reload(true);
                }
            },500);
        });

        //reove from mini cart
        $('body').on('click', '.incart .remove', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = 0;
            _this.updateItem(par.attr('data-proid'), qty);
        });

        var upsellid = "";

        $('body').on('click', '.upsell-replace', function (e) {

            e.preventDefault();
            e.stopPropagation();
            $('#shopify-section-upsells .ajax_loader').addClass('active');
            var productid = $(this).attr('data-product-select');
            upsellid = $(this).attr('data-upsell-id');

            var datas = "updates[" + productid + "]=" + 0 + "&";
            datas += "updates[" +upsellid+ "]=" + 1 + "&";

            // Add to cart.
            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: datas,
                dataType: 'json',
                success: function () {
                    PROJ.ajaxcart.updateCart();
                    $('#shopify-section-upsells .ajax_loader').removeClass('active');
                    $('body,html').removeClass('upsell-cart-ani');
                    $('body,html').addClass('mini-cart');
                    setTimeout(function(){
                        // $('body,html').addClass('mini-cart-ani');
                        $('body,html').removeClass('upsell-cart');

                    },500);
                }
            });

        });

        $('body').on('submit', 'form[action="/cart/add"]', (function (e) {

            e.preventDefault();
            var $addToCartForm = $(this);
            var $addToCartBtn = $('.cart-btn button');
            $('#mini-cart').addClass('loading');

            $addToCartBtn.addClass('disabled').prop('disabled', true);

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                    _this.updateCart();
                    $addToCartBtn.removeClass('disabled').prop('disabled', false);
                    if($('.upsell-single-wrap').length)
                    {
                        $('[data-var-upsell]').hide();
                        var prname = "";
                        if($('.btn.variable.available').length)
                        {
                            $('.upsell-wraps .main-item .ptext span').text(" - " + $('.btn.variable.active').text());
                        }else
                        {
                            $('.upsell-wraps .main-item .ptext span').text("");
                        }
                        var upsl = $('[data-var-upsell='+ $('.product-form .sub-pro .active').attr('varid')+']');
                        if($.trim(upsl.html()))
                        {
                            upsl.show();
                            _this.openupsell();
                        }else
                        {
                            _this.opencart();
                        }

                    }else
                    {
                        _this.opencart();
                    }
                },
                error: function (XMLHttpRequest) {
                    _this.updateCart();

                }
            });
            return false;

        }));



        $('body').on('click','.cart-note-btn', function (e) {
            var dataToSend = "note="+encodeURIComponent($('#cart-note').val());
            $('.cart-note-wrap').removeClass('cartnote');
            $.ajax({
                type: "POST",
                url: "/cart/update.js",
                // data: "{note="+ +"}",
                data: dataToSend ,
                dataType: "json",
                success: function(e) {
                },
                error: function(e, t) {
                },
                complete: function() {
                }
            });
        });

        $('body').on('click','.close-cart-note', function (e) {
         e.preventDefault();
         $('.cart-note-wrap').toggleClass('cartnote');
        });

        $('body').on('click','.quick-pay-btn', function (e) {
         e.preventDefault();
         $('#mini-cart').toggleClass('quickpay');
        });

        $('body').on('click', '[data-protection-id]', function (e) {
            e.preventDefault();
            if($(this).hasClass('active'))
            {
                sessionStorage.setItem('noprotection',true);
                _this.updateItem($(this).attr('data-protection-id'), 0);
            }else
            {
                sessionStorage.clear('noprotection');
                _this.addItem($(this).attr('data-protection-id'));
            }
        });


    },

    updateCart: function () {
        var _this = this;
        $('body,html').removeClass('mini-cart-ani');
        // clearTimeout(cartAnimationOnce);
        // $.get("/cart?view=mini", function (data) {
        $.get("/?section_id=mini-cart", function (data) {

            $('#mini-cart .ajax_place').html($(data));
            var counti = $('[data-icount]').attr('data-icount');

            counti==0? $('.cart-count').text(''): $('.cart-count').text(counti);
            console.log(counti);
            cartAnimationOnce += 1;


        }).done(function (cart) {

            $('#mini-cart').removeClass('loading');
            _this.animateCart();
            // $('body,html').addClass('mini-cart-ani');
            console.log(cartAnimationOnce,"--------");

        });
    },
    animateCart: function () {
        // to update and animate mini cart with total price
        var _this = this;

        $('.ns-target-gift').appendTo('.target-gifts');

        var locks = $('.target-locks .target');
        var progess_bar_val = $('.ns-progress').data('progress'); // total price

        var gifts = $('.ns-target-gift');
        for (var i = 0; i < gifts.length; i++) {
            var target = gifts.eq(i);
            if(progess_bar_val >= target.attr('data-gift-target') && target.hasClass('giftfalse') && target.hasClass('noappgift'))
            {
                _this.addItem(target.attr('data-gift-id'));
                return;
            }else if (progess_bar_val < target.attr('data-gift-target') && target.hasClass('gifttrue')  && target.hasClass('noappgift'))
            {
                _this.updateItem(target.attr('data-gift-id'),0);
                return;
            }else if (target.hasClass('multigift'))
            {
                _this.updateItem(target.attr('data-gift-id'),1);
                return;
            }
        }

        var gap = 100 / (locks.length - 1);
        var current_target;
        var next_target;
        var last_target = locks.eq(locks.length - 1);

        // cartAnimationOnce = setTimeout(function(){},1500);
        locks.each(function(i){
            if(progess_bar_val >= $(this).data('target'))
            {
                var element = $(this);
                current_target = $(this);
                next_target = locks.eq(i+1);
                setTimeout(function() {
                    element.addClass("active");
                }, 300 * i);
            }
        });

        if(next_target) {
            if (next_target.length) {
                var extraval = (progess_bar_val - current_target.data('target')) / (next_target.data('target') - current_target.data('target'));
                var barwidth = (current_target.index() * gap) + (gap * extraval);
                $('.ns-progress-fill').width(barwidth + "%");
            } else {
                $('.ns-progress-fill').width("100%");
            }
        }
        //quickpay buttons
        var quickpay = JSON.parse($('[wallet-configs]').attr('wallet-configs'));
        for (var s = 0; s < quickpay.length; s++) {
            $('#mini-cart').addClass(quickpay[s].name);
        }



        $('body,html').addClass('mini-cart-ani');





    },

    addItem: function (id) {
        var _this = this;

        if(!$('body').hasClass('upsell-cart'))
        {
            $('#mini-cart').addClass('loading');
            $('body,html').addClass('mini-cart');
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                if(!$('body').hasClass('upsell-cart'))
                {
                    _this.updateCart();
                }else
                {
                    PROJ.upsells.opencart();
                    PROJ.upsells.closequickbuy();
                    _this.updateCart();
                }

            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },

    updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');


        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
                if($('body').hasClass('upsell-cart'))
                {
                    PROJ.upsells.opencart();
                }
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },



    giftwrap: function () {
        var _this = this;
        $('body').on('keyup','#gift-note', function (e) {
            var count = $(this).val().length;
            var max = $(this).attr('maxlength');
            $(this).next().html("<strong>"+(max - count) +"</strong>"+ " Characters Remaining");
        });

        $('body').on('click','.gift-wrap-panel .all-close-cart, .gift-wrap-panel .cancel', function (e) {
            $('.gift-wrap-panel ').removeClass('active');
        });
        $('body').on('click','.gift-wrap-box .propose', function (e) {
            if($('.gift-wrap-wrap').hasClass('activegift'))
            {
                var gid = $('[data-gift-id]').attr('data-gift-id');
                $('#mini-cart').addClass('loading');
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates["+gid+"]=0&attributes[gift-note]="+encodeURIComponent(''),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }else
            {
                $('.gift-wrap-panel ').addClass('active');
            }
        });
        $('body').on('click','.gift-wrap-box .edit', function (e) {
            $('.gift-wrap-panel ').addClass('active');
        });
        $('body').on('click','[data-gift-id]', function (e) {
            e.preventDefault();
            var gid = $(this).attr('data-gift-id');
            $('#mini-cart').addClass('loading');
            if($('.gift-wrap-wrap').hasClass('activegift'))
            {
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }else
            {
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates["+gid+"]=1&attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }

        });
    },

    opencart: function () {
        $('body,html').addClass('mini-cart');
        setTimeout(function(){
            $('body,html').addClass('mini-cart-ani');
        },500);
    },
    closecart: function () {
        $('body,html').removeClass('mini-cart')
        setTimeout(function(){
            $('body,html').removeClass('mini-cart-ani');
        },500);
    },
    openupsell: function () {
        $('body,html').addClass('upsell-cart-ani');
        setTimeout(function(){
            $('body,html').addClass('upsell-cart');
        },500);
    },
    closeupsell: function () {
        $('body,html').removeClass('upsell-cart');
        setTimeout(function(){
            $('body,html').removeClass('upsell-cart-ani');
        },500);
    }


};



